// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"B0-z","sponsoredTooltipWrapper":"C0-z","sponsoredTooltip":"D0-z","newCard":"E0-z"};